<button
    #button
    id="csv-importer-upload-button"
    [disabled]="disabled"
    class="primary upload-button"
    (click)="openFileBrowser($event)">
    {{ buttonName }}
</button>
<input
    #importField
    class="hidden-input"
    type="file"
    accept=".csv"
    (change)="onFileChange($event)">

<app-modal-wrapper
    [isOverlayBlurred]="true"
    [isOverlayClickable]="false"
    modalId="assign-csv-headers"
    modalTitle="csv_importer_title"
    modalHeight="800"
    modalWidth="1000"
    [showCloseButton]="false">
    <app-modal-body>
        <p>{{ 'csv_importer_description' | myLbTranslate }}</p>
        <div class="content-space-between">
            <div>
                <span>
                    <strong>{{ 'csv_importer_missing_fields' | myLbTranslate }}&nbsp;</strong>
                    <ng-container *ngIf="tableRequiredMessaging.missingRequiredFields?.length else na">
                        <span class="error-text">{{ tableRequiredMessaging.missingRequiredFields }}</span>
                    </ng-container>
                    <ng-template #na>
                       {{ 'n_a' | myLbTranslate }}
                    </ng-template>
                </span>
            </div>
            <div>
                <span>
                    <strong>{{ 'csv_importer_missing_fields_set' | myLbTranslate }}</strong>
                    {{ tableRequiredMessaging.totalSelectedRequiredFields }}
                </span>
            </div>
        </div>
        <form [formGroup]="formGroup">
            <table id="assignment" class="mock-table" formGroupName="rows">
                <thead>
                <tr>
                    <th>{{ 'csv_importer_heading_csv_headings' | myLbTranslate }}</th>
                    <th></th>
                    <th>{{ 'csv_importer_heading_submission_headings' | myLbTranslate }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let row of getRows(); index as i">
                    <td>{{ row?.value?.header }}</td>
                    <td>
                        <img ngSrc="assets/shared/icons/chevron-right.svg" height="15" width="15" alt="Right arrow"/>
                    </td>
                    <td [formGroupName]="i.toString()">
                        <app-dropdown
                            [dropDownId]="row?.value.header + '-field'"
                            [dropdownWidth]="200"
                            [hiddenContentKeys]="hiddenContentKeys"
                            [formGroup]="formGroup?.get('rows').controls[i]"
                            [startText]="startText"
                            [alwaysShowStartText]="true"
                            [alwaysEnabled]="true"
                            formControlName="field"
                            [content]="dropdown">
                        </app-dropdown>
                    </td>
                </tr>
                </tbody>
            </table>
        </form>
        <div class="content-space-between">
            <div class="content-left">
                <span class="counter">{{ 'csv_importer_number_records' | myLbTranslate }} {{ lineCount }}</span>
                <span class="counter">Errored rows: {{ erroredRows.length }}</span>
            </div>
            <div class="content-right">
                <button
                    *ngIf="erroredRows.length"
                    id="csv-importer-toggle-button"
                    class="primary"
                    (click)="toggleTables()">
                    {{ (viewResults ? 'csv_importer_switch_view_errors' : 'csv_importer_switch_view_results') | myLbTranslate }}
                </button>
                <button
                    *ngIf="lineCount >= autoPreviewCutOff"
                    id="csv-importer-preview-button"
                    class="primary"
                    (click)="preview()">
                    {{ 'csv_importer_preview' | myLbTranslate }}
                </button>
            </div>
        </div>
        <ng-container *ngIf="viewResults else viewErrors">
            <table *ngIf="tableRows?.length" id="results" class="mock-table">
                <thead>
                <tr>
                    <th *ngIf="showRowsNumbers" class="row-numbers">#</th>
                    <th *ngFor="let header of tableHeaders">{{ header | titlecase }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let row of tableRows; index as i">
                    <td *ngIf="showRowsNumbers" class="row-numbers">{{ i + 1 }}</td>
                    <ng-container *ngFor="let header of tableHeaders">
                        <td [class.centered]="columnIsNumber(row?.[header])">
                            <div class="csv-image-wrapper">
                                <img
                                    *ngIf="row?.[header] && row[header]?.toString().startsWith('ERROR')"
                                    class="error-icon"
                                    ngSrc="./assets/shared/icons/notification-solid-exclamation-triangle.svg"
                                    alt="Expiry icon"
                                    height="20"
                                    width="20"/>
                                {{ valueIncludesExcludedItems(row?.[header]) ? (row?.[header].toString() | titlecase) : row?.[header] }}
                            </div>
                        </td>
                    </ng-container>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <td colspan="100%">
                        <span>
                            {{ 'csv_importer_number_records' | myLbTranslate }} {{ tableRows?.length }}
                        </span>
                    </td>
                </tr>
                </tfoot>
            </table>
        </ng-container>
        <ng-template #viewErrors>
            <div class="content error-wrapper">
                <img
                    class="error-icon"
                    ngSrc="./assets/shared/icons/notification-solid-exclamation-triangle.svg"
                    alt="Expiry icon"
                    height="20"
                    width="20"/>
                <span class="error">{{ errorMessage }}</span>
            </div>
            <table *ngIf="erroredRows?.length" id="errorsTable" class="mock-table">
                <thead>
                <tr>
                    <th *ngFor="let header of csvHeaders" class="error">
                        {{ header.startsWith('empty') ? null : (header | titlecase) }}
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let row of erroredRows">
                    <ng-container *ngFor="let column of row">
                        <td class="error">
                            {{ column }}
                        </td>
                    </ng-container>
                </tr>
                </tbody>
            </table>
        </ng-template>
    </app-modal-body>
    <app-modal-footer>
        <button id="csv-importer-cancel-button" class="outline" (click)="cancel()">
            {{ 'cancel' | myLbTranslate }}
        </button>
        <button
            id="csv-importer-confirm-button"
            class="primary"
            [disabled]="submitIsDisabled()"
            (click)="submit()">
            {{ 'confirm' | myLbTranslate }}
        </button>
    </app-modal-footer>
</app-modal-wrapper>
